import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FooterResponse } from './models/footer.response';
import { FooterFactory } from './footer.factory';
import { Footer } from './models/footer.model';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  private readonly footerFactory = inject(FooterFactory);
  private readonly http = inject(HttpClient);

  getFooter(locale: string): Observable<Footer | null> {
    const url = `${environment.apiUrl}/footer`;

    return this.http.get<FooterResponse>(url, { params: { locale } })
      .pipe(map((response) => this.footerFactory.buildFooter(response)));
  }
}
